<template>
	<ul class="feature-list feature-list--tighter">
		<li
			v-for="(item, i) in features"
			:key="'item' + i"
		>
			<Icon icon="checkmark"/>
			<span class="text" v-html="item"/>
		</li>
	</ul>
</template>

<script>
import Icon from "@/vue/icon/Icon.vue";

const FEATURES = [
	'<span>Kostenfrei</span> Job-Profil veröffentlichen',
	'Kostenfrei aktiv nach <span>passenden Bewerberprofilen</span> suchen',
	'Durch das <span>skilldoo-Matching</span> wird der Job passenden Bewerbern vorgeschlagen.',
	'<span>Anonym:</span> eure Daten sind für einen anderen User erst sichtbar, wenn du sie freigibst.',
	'Ihr bezahlt erst, wenn ihr jemanden kontaktiert oder eine Kontaktanfrage annehmen wollt. Davor erhältst du einen Hinweis zur Freigabe.',
];

export default {
	components: {
		Icon,
	},

	computed: {
		features ()
		{
			return FEATURES;
		},
	}
}
</script>
